<template>
  <v-autocomplete
      class="select-organization"
      ref="input"
      v-model="data"
      :label="label"
      :loading="loading"
      :items="items"
      v-on="$listeners"
      :rules="rules"
      :item-text="itemText"
      :item-value="itemValue"
      :search-input.sync="searchText"
      :solo="solo"
      :outlined="outlined"
      :dense="dense"
      :flat="flat"
      :rounded="rounded"
      :clearable="clearable"
      :append-icon="appendIcon"
      :readonly="readonly"
      :small-chips="chips"
      deletable-chips
      :disabled="disabled"
      :multiple="multiple"
      :placeholder="placeholder"
      :persistent-placeholder="!!placeholder"
      :hint="hint"
      :persistent-hint="persistentHint"
      @keydown="loadItems(searchText)"
      no-filter
      :hide-details="!hint"
      hide-no-data
      autocomplete="nope"
  >
    <template #item="{item, on, attrs}">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-avatar>
          <v-icon left>{{ commonIcons().organization.type[item.type] }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ item.path }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template #selection="{item}"  v-if="!selectionWithNoExtra">
      <div class="item">
        <div class="title">
          {{ item.name }}
        </div>
        <div class="subtitle-1">
          {{ item.path }}
        </div>
      </div>
    </template>

  </v-autocomplete>
</template>

<script>

import OrganizationRepository from "@repository/OrganizationRepository";

export default {
  data(){
    return {
      loaded: false,
      loading: false,
      items: [],
      data: this.value,
      searchText: "",
    }
  },

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: [String, Array], default: null },
    type: String,
    clearable: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    solo: Boolean,
    dense: Boolean,
    flat: Boolean,
    outlined: Boolean,
    rounded: Boolean,
    rules: Array,
    multiple: Boolean,
    appendIcon: String,
    placeholder: String,
    chips: Boolean,
    label: String,
    selectionWithNoExtra: Boolean,
    withoutFilter: Boolean,
    perimeterId: String,
    subPerimeterId: String,
    instanceId: String,
    itemText: {type: String, default: 'name'},
    itemValue: {type: String, default: 'id'},
    filter: {type: Function, default: null},
    hint: String,
    persistentHint: Boolean,
    canBeInvoiceRecipient: {type: Boolean, default: null},
  },

  watch: {

    data(val) {
      this.$emit('input', val)
      if(!this.loaded) {
        this.loadItems(val)
      }
    },

    value(val) {
      this.data = val
    },

    perimeterId() {
      if(this.searchText) {
        this.searchText = ''
      } else {
        this.loadItems('')
      }
    },

    subPerimeterId() {
      if(this.searchText) {
        this.searchText = ''
      } else {
        this.loadItems('')
      }
    },

    searchText(val) {
      if(this.loaded) {
        this.loadItems(val)
      }
    }
  },

  mounted() {
    if(this.data) {
      this.loadItems(this.data)
    }
  },

  methods: {
    loadItems(searchText) {

      if(Array.isArray(searchText)) {
        searchText = searchText.join(',')
      }

      this.loading = true
      const payload = {
        searchText: searchText ?? '',
        withoutFilter: this.withoutFilter,
        perimeterId: this.perimeterId,
        subPerimeterId: this.subPerimeterId,
        limit: 25,
      }
      if (this.canBeInvoiceRecipient !== null) {
        payload.canBeInvoiceRecipient = this.canBeInvoiceRecipient
      }
      OrganizationRepository.search(payload, this.instanceId).then(result => {
        this.items = this.filter ? (result.items || []).filter(this.filter) : result.items
        this.loading = false
        this.loaded = true
      }).catch(err => {
        this.notifyError(err)
        this.loading = false
      })
    },

    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">

.select-organization {
  &.v-input--is-focused {
    .v-select__selections {
      input {
        min-width: 30px !important;
      }
    }
  }
  .item {
    margin-right: 10px;
    .title {
      font-size: 18px !important;
      line-height: 18px;
      font-weight: bold;
      margin: 3px 0;
      color: #E53C22;
    }
    .subtitle-1 {
      margin: 3px 0;
      font-size: 16px !important;
      line-height: 16px;
    }
  }
  .v-messages__message {
    font-weight: 400;
  }
}
</style>
